// 字符串反混淆函数
function deobfuscateString(obfuscatedString) {
    // 将Base64编码的混淆字符串转换为字节数组
    var obfuscatedBytes = new Uint8Array(window.atob(obfuscatedString).split("").map(char => char.charCodeAt(0)));

    // 创建一个空的字节数组来存储反混淆后的字节
    var deobfuscatedBytes = new Uint8Array(obfuscatedBytes.length);

    // 遍历混淆字符串的每个字节
    for (var i = 0; i < obfuscatedBytes.length; i++) {
        // 获取当前字节的值
        var byteValue = obfuscatedBytes[i];

        // 对字节值进行反混淆操作（这里使用了一个简单的减法操作）
        var deobfuscatedValue = byteValue - 1;

        // 将反混淆后的字节值存储在反混淆字节数组中
        deobfuscatedBytes[i] = deobfuscatedValue;
    }

    // 将反混淆后的字节数组转换为原始字符串
    var deobfuscatedString = new TextDecoder().decode(deobfuscatedBytes);

    return deobfuscatedString;
}

/**
 * 域名管理器: 用于管理和映射不同应用的下载域名
 * 官网域名 与 CDN域名 的映射关系
 * Xender-Android, MP3 Box, MX, SY
 */
class DomainMgr {
    constructor() {
        this.domainMap = new Map();
        this.init();
    }

    init() {
        this.domainMap.set('bXBkYm1pcHR1', 'Z3R1YnVqZC9ucTQuY3B5Ljo2Mzg1ODM2L2Rwbg==');                 // localhost: fstatic.mp3-box-95274725.com
        this.domainMap.set('ZGd5ZWRlb3Z3Z3Nxc291', 'dy9kZ3llZGVvdndnc3Fzb3UvZHBu');                     // cfxdcdnuvfrprnt: v.cfxdcdnuvfrprnt.com
        this.domainMap.set('eWZvZWZz', 'dy9kZ3llZGVvdndnc3Fzb3UvZHBu');                                 // xender: v.cfxdcdnuvfrprnt.com
        this.domainMap.set('dGlic2ZqdQ==', 'dy9kZ3llZGVvdndnc3Fzb3UvZHBu');                             // shareit: v.cfxdcdnuvfrprnt.com
        this.domainMap.set('dGlic2ZuZg==', 'dy9kZ3llZGVvdndnc3Fzb3UvZHBu');                             // shareme: v.cfxdcdnuvfrprnt.com
        this.domainMap.set('bnZ0amR5LmVweG9tcGJl', 'Z3R1YnVqZC9ucTQuY3B5Ljo2Mzg1ODM2L2Rwbg==');         // musicx-download: fstatic.mp3-box-95274725.com
        this.domainMap.set('bnE0LmNweQ==', 'Z3R1YnVqZC9ucTQuY3B5Ljo2Mzg1ODM2L2Rwbg==');                 // mp3-box: fstatic.mp3-box-95274725.com
        this.domainMap.set('bnZ0ankuY3B5', 'Z3R1YnVqZC9ucTQuY3B5Ljo2Mzg1ODM2L2Rwbg==');                 // musix-box: fstatic.mp3-box-95274725.com
        this.domainMap.set('bnZ0anllcHhvbXBiZQ==', 'Z3R1YnVqZC9ueW1iYm9nL2Rwbg==');                     // musixdownload: fstatic.mxlaanf.com
        this.domainMap.set('bnZ0ankuYnFx', 'Z3R1YnVqZC9ueW1iYm9nL2Rwbg==');                             // musix-app: fstatic.mxlaanf.com
        this.domainMap.set('bnltYmJvZw==', 'Z3R1YnVqZC9ueW1iYm9nL2Rwbg==');                             // mxlaanf: fstatic.mxlaanf.com
        this.domainMap.set('dGJ3ZnNuYnVmeQ==', 'Z3R1YnVqZC90ei53aWc5OmdlajZjL2Rwbg==');                 // savermatex: fstatic.sy-vhf89fdi5b.com
        this.domainMap.set('enB2dXZjZi5udnRqZC5lcHhvbXBiZQ==', 'Z3R1YnVqZC90ei53aWc5OmdlajZjL2Rwbg=='); // youtube-music-download: fstatic.sy-vhf89fdi5b.com
        this.domainMap.set('dHoud2lnOTpnZWo2Yw==', 'Z3R1YnVqZC90ei53aWc5OmdlajZjL2Rwbg==');             // sy-vhf89fdi5b: fstatic.sy-vhf89fdi5b.com
    }

    /**
     * 
     * @param {xender-android} appName 
     * @returns 
     */
    getDomainFromeLink() {
        var u = new URL(location.href);
        var domain_str = u.hostname;

        for (var [key, value] of this.domainMap.entries()) {
            if (domain_str.includes(deobfuscateString(key))) {
                return deobfuscateString(value);
            }
        }

        return deobfuscateString('eWZvZWZz');
    }
}

export default DomainMgr;



// WEBPACK FOOTER //
// ./src/assets/js/domain_mgr.js